import React, { useState } from "react";
import ApplicationListItem from "./ApplicationListItem";
import NoResults from "../../../common/NoResults";
import Modal from "../../../common/management/Modal";
import SonicApplication from "../../../common/classes/SonicApplication";
import { ImageSourceSetData } from "../../../common/classes/ImageSourceSet";
import { CategoryState } from "../../../utils/CategoryState";
import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  application: Array<SonicApplication>;
  projects: Array<{
    name: string;
    owner_name: string;
    owner_email: string;
    owner_roles: Array<string>;
    owner_id: string;
    confirmations?: string;
    imgs: Array<ImageSourceSetData>;
  }>;
  isSelect: boolean;
};
const ApplicationList: React.FC<Props> = ({
  application,
  projects,
  isSelect,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<string>("");

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleModalProps = (value: string) => {
    setModalProps(value);
  };

  if (application.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["application"]}`}
      >
        <div className={styles["column"]}>
          <div>応募申請者</div>
          <span>名前</span>
        </div>
        <div className={styles["column"]}>
          <div>応募プロジェクト</div>
          <span>プロジェクト名</span>
        </div>
        <div>申請日時</div>
        <div>ステータス</div>
        <div>アクション</div>
      </div>
      {application.map((item, i) => (
        <ApplicationListItem
          key={i}
          id={item.id}
          status={item.status}
          timestamp={item.timestamp}
          memo={item.memo}
          projectName={projects?.[i].name}
          applicantName={
            !isSelect && item.applicant_full_name
              ? item.applicant_full_name
              : item.applicant_name
          }
          handleModal={handleModal}
          handleModalProps={handleModalProps}
          isSelect={isSelect}
        />
      ))}
      {showModal === true ? (
        <Modal
          closeModal={handleModal}
          categoryState={CategoryState.Memo}
          headText="メモを確認"
        >
          {modalProps}
        </Modal>
      ) : null}
    </div>
  );
};

export default ApplicationList;
